import { NOTIFICATION_DELETE_ALL_ITEMS, NOTIFICATION_DELETE_ALL_QUEUE } from 'app/utils/constants';
export const addQueue = (value) => {
    return {
        type: 'NOTIFICATION_ADD_QUEUE',
        payload: value,
    };
};
export const deleteQueue = (value) => {
    return {
        type: 'NOTIFICATION_DELETE_QUEUE',
        payload: value,
    };
};
export const deleteAllQueue = (items) => {
    return {
        type: NOTIFICATION_DELETE_ALL_QUEUE,
        payload: items,
    };
};
export const addItem = (value) => {
    return {
        type: 'NOTIFICATION_ADD_ITEM',
        payload: value,
    };
};
export const deleteItem = (id) => {
    return {
        type: 'NOTIFICATION_DELETE_ITEM',
        payload: {
            id,
        },
    };
};
export const deleteAllItems = () => {
    return {
        type: NOTIFICATION_DELETE_ALL_ITEMS,
    };
};
export const addEventQueue = (value) => {
    return {
        type: 'NOTIFICATION_ADD_EVENT_QUEUE',
        payload: value,
    };
};
export const addParkingAlert = (value) => {
    return {
        type: 'NOTIFICATION_ADD_PARKING_ALERT',
        payload: value,
    };
};
